import { useId, type ComponentProps } from "react";

const MinimizeIcon = (props: ComponentProps<"svg">) => {
  const id = useId();

  const path = `url(${id})`;
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath={path}>
        <path
          d="M17.7562 0.248165C17.6779 0.169505 17.5847 0.107093 17.4822 0.0645072C17.3796 0.0219214 17.2696 0 17.1586 0C17.0475 0 16.9376 0.0219214 16.835 0.0645072C16.7325 0.107093 16.6393 0.169505 16.5609 0.248165L10.957 5.85207V2.1016C10.957 1.87783 10.8681 1.66322 10.7099 1.50498C10.5517 1.34675 10.3371 1.25785 10.1133 1.25785C9.8895 1.25785 9.67489 1.34675 9.51666 1.50498C9.35843 1.66322 9.26953 1.87783 9.26953 2.1016V7.86723C9.26953 8.09734 9.36094 8.31804 9.52366 8.48075C9.68638 8.64347 9.90707 8.73488 10.1372 8.73488H15.8989C16.1199 8.73492 16.3321 8.64825 16.4899 8.4935C16.6477 8.33875 16.7385 8.12827 16.7427 7.90731C16.7518 7.43445 16.3532 7.04738 15.88 7.04738H12.1534L17.7562 1.44348C17.8349 1.36509 17.8973 1.27195 17.9399 1.16939C17.9825 1.06683 18.0044 0.956871 18.0044 0.845822C18.0044 0.734772 17.9825 0.624815 17.9399 0.522256C17.8973 0.419697 17.8349 0.326553 17.7562 0.248165Z"
          fill={props.fill || "#183E7A"}
        />
        <path
          d="M7.86652 9.25781H2.10477C1.88376 9.25777 1.67157 9.34444 1.51379 9.4992C1.35601 9.65395 1.26525 9.86443 1.26102 10.0854C1.25187 10.5582 1.65055 10.9453 2.12375 10.9453H5.85207L0.247109 16.5503C0.0888871 16.7085 0 16.9231 0 17.1469C0 17.3706 0.0888871 17.5852 0.247109 17.7435C0.405341 17.9017 0.619944 17.9906 0.84371 17.9906C1.06748 17.9906 1.28208 17.9017 1.44031 17.7435L7.04422 12.1396V15.8914C7.04422 16.1152 7.13311 16.3298 7.29135 16.4881C7.44958 16.6463 7.66419 16.7352 7.88797 16.7352C8.11174 16.7352 8.32636 16.6463 8.48459 16.4881C8.64282 16.3298 8.73172 16.1152 8.73172 15.8914V10.1258C8.7319 9.89604 8.6409 9.67558 8.47869 9.51283C8.31647 9.35009 8.0963 9.25837 7.86652 9.25781Z"
          fill={props.fill || "#183E7A"}
        />
      </g>
      <defs>
        <clipPath id={id}>
          <rect width="18" height="18" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default MinimizeIcon;
